const state = {
    lang: 'ru', // default language
    size: 'xl'  // default screen size
}

const getters = {
    StateLang: (state) => state.lang,
    StateScreenSize: (state) => state.size
}

const actions = {
    async ActionLang({ commit }, lang) {
        try { await commit("setLang", lang).then(res=>res) } catch { }
        return true
    },
    async ActionScreenSize({ commit }, size) {
        try { await commit("setScreenSize", size) } catch { }
        return true
    }
}

const mutations = {
    setLang(state, lang) {
        state.lang = lang
    },
    setScreenSize(state, size) {
        state.size = size
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}